import {
  number,
  oneOfType,
  shape,
  string,
  func,
  bool,
  array,
  object,
} from 'prop-types';

const priceTypePropTypes = shape({
  value: oneOfType([string, number]),
  currency: string,
});

const hotelCardPropTypes = {
  name: string,
  baseRate: priceTypePropTypes,
  strikethroughPrice: priceTypePropTypes,
  image: string,
  images: array,
  onLoadThumbnailImage: func,
  location: string,
  priceHintText: string,
  guestHintText: string,
  guestCount: number,
  onClick: func,
  bigPoint: shape({
    label: string,
    value: string,
    unit: string,
  }),
  highlight: bool,
  paymentDiscountType: string,
  paymentDiscountDescription: string,
  isShowCarousel: bool,
  tripAdvisorData: object,
  enableTotalGuestPrice: bool,
  hideBigPoints: bool,
  showSelectRoomCTA: bool,
  onSelectRoomClicked: func,
  perPersonBaseRate: priceTypePropTypes,
  perPersonStrikeThroughPrice: priceTypePropTypes,
  isHotel: bool,
  override: bool,
};

export default hotelCardPropTypes;
